import { createContext, useContext, type RefObject } from 'react';

export const PortalContainerContext = createContext<
  RefObject<HTMLElement | null> | undefined
>(undefined);

export const usePortalContainer = () => useContext(PortalContainerContext);
